import {
  SET_USER_INFO,
  SET_USER_COURSES_BALANCE,
  SET_USER_BALANCE,
  SET_CURRENT_USER_BALANCE,
  DECREMENT_COIN,
  TOGGLE_CREATORS_AREA_BANNER,
} from '@/store/mutations.js';

import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

export default {
  state: {
    info: null,
    userCoursesCount: 0,
    userCoursesBalance: 0,
    showCreatorsAreaBanner: false,
  },

  mutations: {
    [SET_USER_INFO]: (state, payload) => {
      state.info = payload;
      state.userCoursesCount = payload.courseCount || 0;
    },

    [SET_USER_COURSES_BALANCE]: (state, payload) => {
      state.userCoursesBalance = payload;
    },

    // TODO переделать
    [SET_USER_BALANCE]: (state, { amount }) => {
      state.info.balance = (Number(state.info.balance) + amount).toFixed(2);
    },

    [SET_CURRENT_USER_BALANCE]: (state, { amount }) => {
      state.info.balance = amount.toFixed(2);
    },

    [DECREMENT_COIN]: (state, { coin }) => {
      state.info.coin = coin;
    },

    [TOGGLE_CREATORS_AREA_BANNER]: (state, payload) => {
      state.showCreatorsAreaBanner = payload;
    },
  },

  actions: {
    async getUserInfo({ commit }) {
      const res = await apiRequest('user', 'GET', null, true);

      if (res.error) {
        notify({ text: res.error });
        throw { customeError: res.error };
      }

      const {
        id,
        name,
        last_name: lastName,
        email,
        balance,
        gold,
        course_creator,
        courses_count,
        ref_code: refCode,
        star_coef: starCoef,
        bot_url,
        bot_text,
        status,
      } = res.success;

      commit(SET_USER_INFO, {
        id,
        name,
        lastName,
        email,
        balance: balance.toFixed(2),
        coin: gold,
        courseCreator: course_creator,
        courseCount: courses_count,
        refCode,
        starCoef,
        bot_url,
        bot_text,
        status,
      });
    },

    async getUserCoursesBalance({ commit }) {
      const res = await apiRequest('my/courses/balance', 'GET', null, true);

      if (res.success) {
        commit(SET_USER_COURSES_BALANCE, res.success.amount.toFixed(2));
      }
    },
  },
};
